import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.4 5.2c-1.794 1.346-3.417 1.655-4.984 1.493-1.635-.17-3.243-.85-5.022-1.612l-.068-.03c-1.703-.729-3.571-1.53-5.536-1.733-2.053-.213-4.177.226-6.378 1.873a1 1 0 0 0-.412.81v21a1 1 0 0 0 2 0v-5.486c1.637-1.104 3.134-1.358 4.585-1.208 1.634.17 3.242.85 5.021 1.612l.068.03c1.703.73 3.571 1.53 5.536 1.733 2.057.213 4.184-.227 6.39-1.882a1 1 0 0 0 .4-.8V6a1 1 0 0 0-1.6-.8M6 19.198a8.4 8.4 0 0 1 4.79-.88c1.965.203 3.834 1.004 5.536 1.734l.068.029c1.78.762 3.387 1.443 5.022 1.612 1.45.15 2.947-.104 4.584-1.208V7.802a8.4 8.4 0 0 1-4.79.88c-1.965-.203-3.833-1.004-5.536-1.734l-.068-.029c-1.78-.762-3.387-1.443-5.021-1.612-1.45-.15-2.948.104-4.585 1.208z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconFlag = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFlag);
export default Memo;
